import * as uuid from "uuid";
import EventManager from "../../store/sqftEventManager";
import workspace from "../workspace";

export default class SQFTShapeOffset {
  id;
  parent;
  animationPoints = [];
  state = {
    isHidden: false
  };
  params = {
    priority: EventManager.priorities.SEGMENT,
  };
  design = {
    lineWidth: 1,
    strokeStyle: 'rgba(137,137,137,0.6)',
  };

  constructor(parent, state = {}, params = {}, design = {}) {
    this.state = Object.assign(this.state, state);
    this.params = Object.assign(this.params, params);
    this.design = Object.assign(this.design, design);
    this.parent = parent;
    this.id = uuid.v4();
    this.initEvents();
  }

  getParent = () => {
    return this.parent;
  }

  setParent = (value) => {
    this.parent = value;
  }

  getPosition = () => {
    return this.parent.getPosition();
  }

  init = () => {
    this.initEvents();
  }

  initEvents() {
    EventManager.addEvent(
      EventManager.events.MOUSE_MOVE,
      this.onMouseMove.bind(this),
      this,
      this.params.priority
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_DOWN,
      this.onMouseDown.bind(this),
      this,
      this.params.priority
    );
    EventManager.addEvent(
      EventManager.events.MOUSE_UP,
      this.onMouseUp.bind(this),
      this,
      this.params.priority
    );
    EventManager.addEvent(
      EventManager.events.RENDER,
      this.render.bind(this),
      this,
      this.params.priority
    );
  }

  onMouseMove() {
  }

  onMouseUp() {
  }

  onMouseDown() {
  }

  delete() {
    this.deregisterEvents();
  }

  destroy() {
    this.delete();
  }

  hide() {
    if (!this.state.isHidden) {
      this.deregisterEvents();
      this.state.isHidden = true
    }
  }

  restore() {
    if (this.state.isHidden) {
      this.reInitEvents();
      this.state.isHidden = false
    }
  }

  deregisterEvents = () => {
    EventManager.removeEvent(this);
  }

  reInitEvents = () => {
    this.initEvents();
  }

  animateShapeTransition(newShape, callback, duration = 0.75 * 1000) { // 10 seconds = 10000 milliseconds
    if (!newShape) {
      console.error("Invalid new shape.");
      return;
    }

    if (newShape.id === this.parent.id) {
      return;
    }

    const originalShapePoints = this.calculateOutlineV2(this.parent.getPointsPointField(), 10);
    const newShapePoints = this.calculateOutlineV2(newShape.getPointsPointField(), 10);

    // Animation start time
    const startTime = new Date().getTime();

    const animate = () => {
      const elapsed = new Date().getTime() - startTime;
      const t = Math.min(elapsed / duration, 1);

      let interpolatedShape = [];
      for (let i = 0; i < Math.max(originalShapePoints.length, newShapePoints.length); i++) {
        // if we have less points in new shape
        const pointNew = newShapePoints[i % newShapePoints.length];
        // if we have less points in original shape
        const pointOriginal = originalShapePoints[i % originalShapePoints.length];

        interpolatedShape.push({
          x: pointOriginal.x + t * (pointNew.x - pointOriginal.x),
          y: pointOriginal.y + t * (pointNew.y - pointOriginal.y)
        });
      }

      this.animationPoints = interpolatedShape;

      if (t < 1) {
        requestAnimationFrame(animate);
      } else {
        this.animationPoints = [];
        this.setParent(newShape);
        callback();
      }
    };
    // begin animation
    animate();
  }

  render = (ctx) => {
    if (workspace && workspace.getState().loading) return;
    let offsetPoints;

    // if we have animation points the we will render them otherwise we will render shape points
    if (this.animationPoints.length > 0) {
      offsetPoints = this.calculateOutlineV2(this.animationPoints, 10);
    } else {
      const parentPoints = this.parent.getPointsPointField();
      offsetPoints = this.calculateOutlineV2(parentPoints, 10);
    }

    //console.log("parentPoints", parentPoints);
    //console.log("offsetPoints", offsetPoints);

    // let tempPoints = [
    //   {x: 50, y: 50},
    //   {x: 150, y: 50},
    //   {x: 150, y: 150},
    //   {x: 50, y: 150}
    // ];
    //let tempPointsOffset = this.calculateOffsetPoints(tempPoints, 10);
    //console.log("tempPoints", tempPoints);
    //console.log("tempPointsOffset", tempPointsOffset);

    //debugger // eslint-disable-line no-debugger
    ctx.save();
    ctx.beginPath();
    ctx.setLineDash([7, 5]);
    offsetPoints.forEach((p, i) => {
      if (i === 0) ctx.moveTo(p.x, p.y);
      else ctx.lineTo(p.x, p.y);
    });
    ctx.strokeStyle = this.design.strokeStyle;
    ctx.lineWidth = 1;
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  };

  calculateOutlineV2(points, offset) {
    let outlinePoints = [];

    for (let i = 0; i < points.length; i++) {
      let A = points[i];
      let B = points[(i + 1) % points.length];

      // Вектор AB
      let dx = B.x - A.x;
      let dy = B.y - A.y;

      // Вектор нормали (-dy, dx) или (dy, -dx)
      // В зависимости от того, в каком направлении идут точки
      let nx = dy;
      let ny = -dx;

      // Нормализуем вектор нормали
      let length = Math.sqrt(nx * nx + ny * ny);
      nx /= length;
      ny /= length;

      // Добавляем точки обводки с учетом смещения
      outlinePoints.push({
        x: A.x + nx * offset,
        y: A.y + ny * offset
      });
      outlinePoints.push({
        x: B.x + nx * offset,
        y: B.y + ny * offset
      });
    }

    return outlinePoints;
  }

  calculateOffsetPoints = (points, offsetDistance) => {
    let offsetPoints = [];

    points = [points[points.length-1], ...points, points[0], points[1]];

    for (let i = 1; i < points.length-2; i++) {
      let prev = points[i-1];
      let curr = points[i];
      let next = points[i+1];

      let dir1 = {x: curr.x - prev.x, y: curr.y - prev.y};
      let dir2 = {x: next.x - curr.x, y: next.y - curr.y};

      let norm1 = {x: dir1.y, y: -dir1.x};
      let norm2 = {x: dir2.y, y: -dir2.x};

      // Проверка острого угла
      let dotProduct = norm1.x * norm2.x + norm1.y * norm2.y;
      let avgNorm;
      if (dotProduct < 0) {
        avgNorm = i === 1 ? norm1 : norm2; // Использование нормали для более "плоского" отрезка
      } else {
        avgNorm = {x: (norm1.x + norm2.x) / 2, y: (norm1.y + norm2.y) / 2};
      }

      let length = Math.sqrt(avgNorm.x * avgNorm.x + avgNorm.y * avgNorm.y);
      let unitNorm = {x: avgNorm.x / length, y: avgNorm.y / length};

      offsetPoints.push({
        x: curr.x + unitNorm.x * offsetDistance,
        y: curr.y + unitNorm.y * offsetDistance
      });
    }
    return offsetPoints;
  }

  // offsetLine = (points, distance) => {
  //   let offsetPoints = [];
  //
  //   for (let i = 0; i < points.length - 1; i++) {
  //     let p0 = points[i];
  //     let p1 = points[i + 1];
  //
  //     // Вычислить направление отрезка
  //     let dx = p1.x - p0.x;
  //     let dy = p1.y - p0.y;
  //
  //     // Вычислить длину вектора
  //     let len = Math.sqrt(dx * dx + dy * dy);
  //
  //     // Нормализовать вектор
  //     dx /= len;
  //     dy /= len;
  //
  //     // Вычислить нормаль (перпендикуляр)
  //     //let nx = -dy;
  //     //let ny = dx;
  //     let nx = dy;
  //     let ny = -dx;
  //
  //     // Создать офсетную точку
  //     offsetPoints.push({
  //       x: p0.x + nx * distance,
  //       y: p0.y + ny * distance
  //     });
  //   }
  //
  //   // Добавить последнюю точку
  //   let p0 = points[points.length - 2];
  //   let p1 = points[points.length - 1];
  //
  //   // Вычислить направление отрезка
  //   let dx = p1.x - p0.x;
  //   let dy = p1.y - p0.y;
  //
  //   // Вычислить длину вектора
  //   let len = Math.sqrt(dx * dx + dy * dy);
  //
  //   // Нормализовать вектор
  //   dx /= len;
  //   dy /= len;
  //
  //   // Вычислить нормаль (перпендикуляр)
  //   //let nx = -dy;
  //   //let ny = dx;
  //   let nx = dy;
  //   let ny = -dx;
  //
  //   offsetPoints.push({
  //     x: p1.x + nx * distance,
  //     y: p1.y + ny * distance
  //   });
  //   //console.log("offsetPoints", offsetPoints);
  //   return offsetPoints;
  // }
}
